import { render, staticRenderFns } from "./SettingEmailsView.vue?vue&type=template&id=b5c26960"
import script from "./SettingEmailsView.vue?vue&type=script&lang=js"
export * from "./SettingEmailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports